export default function SideBarNotificationIco() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.61719 15H3.2216C1.96317 15 1.33396 15 1.20157 14.9023C1.05284 14.7925 1.0165 14.7277 1.00039 14.5436C0.986055 14.3797 1.3717 13.7486 2.143 12.4866C2.93935 11.1835 3.61555 9.2862 3.61555 6.6C3.61555 5.11479 4.24769 3.69041 5.3729 2.6402C6.49812 1.59 8.02424 1 9.61554 1C11.2068 1 12.7329 1.59 13.8581 2.6402C14.9834 3.69041 15.6155 5.11479 15.6155 6.6C15.6155 9.2862 16.2917 11.1835 17.0881 12.4866C17.8593 13.7486 18.245 14.3797 18.2307 14.5436C18.2146 14.7277 18.1782 14.7925 18.0295 14.9023C17.8971 15 17.2679 15 16.0095 15H12.6155M6.61719 15L6.61555 16C6.61555 17.6569 7.95874 19 9.61554 19C11.2724 19 12.6155 17.6569 12.6155 16V15M6.61719 15H12.6155"
        stroke="#FA4F96"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
